import { PageController } from '@client/components/_core/layout/PageController';
import { CallLogEdit } from '@client/components/claims/CallLogEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useClaimInteractionAccess } from '../useClaimInteractionAccess';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit call log',
        },
    },
    params: {
        parse({ callLogId }) {
            return {
                callLogId: BigInt(callLogId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { canEdit } = useClaimInteractionAccess();
    const navigate = useNavigate();

    // CUR-725: closed claims are read-only — call logs cannot be edited.
    useEffect(() => {
        if (!canEdit) {
            navigate({ moveInMatches: -1 });
        }
    }, [canEdit]);

    return (
        <PageController route={Route}>
            <CallLogEdit action={['edit', Route.useParams().callLogId]} />
        </PageController>
    );
}
